<div class="">
  <div class="mx-auto">
    <!-- Header -->
    <div class="flex justify-between items-center mb-10">
      <h2 class="text-4xl font-bold text-gray-800">Employee Form</h2>
    </div>

    <form
      [formGroup]="employeeForm"
      (ngSubmit)="onSubmit()"
      autocomplete="off"
      class="bg-white rounded-2xl shadow p-10"
    >
      @if (employeeId) {
      <!-- ID -->
      <div class="mb-8">
        <label for="empId" class="block text-2xl font-bold text-gray-700 mb-2">
          Employee ID <span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <input
          id="empId"
          type="text"
          [value]="employeeId"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
          disabled
        />
      </div>
      }

      <!-- First Name -->
      <div class="mb-8">
        <label
          for="firstName"
          class="block text-2xl font-bold text-gray-700 mb-2"
        >
          First Name <span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <input
          id="firstName"
          type="text"
          formControlName="firstName"
          placeholder="Enter first name"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <!-- Last Name -->
      <div class="mb-8">
        <label
          for="lastName"
          class="block text-2xl font-bold text-gray-700 mb-2"
        >
          Last Name <span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <input
          id="lastName"
          type="text"
          formControlName="lastName"
          placeholder="Enter last name"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <!-- Email -->
      <div class="mb-8">
        <label for="email" class="block text-2xl font-bold text-gray-700 mb-2">
          Email <span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <input
          id="email"
          type="email"
          formControlName="email"
          placeholder="Enter email address"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <!-- Phone -->
      <div class="mb-8">
        <label for="phone" class="block text-2xl font-bold text-gray-700 mb-2">
          Phone <span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <input
          id="phone"
          type="tel"
          formControlName="phone"
          placeholder="Enter your phone number"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <!-- Join Date -->
      <div class="mb-8">
        <label
          for="joinDate"
          class="block text-2xl font-bold text-gray-700 mb-2"
        >
          Join Date <span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <input
          id="joinDate"
          type="date"
          formControlName="joinDate"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <!-- Status -->
      <div class="mb-8">
        <label for="status" class="block text-2xl font-bold text-gray-700 mb-2">
          Status<span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <select
          id="status"
          formControlName="status"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          <option *ngFor="let s of statusOptions" [value]="s">{{ s }}</option>
        </select>
      </div>

      <!-- Department -->
      <div class="mb-8">
        <label
          for="department"
          class="block text-2xl font-bold text-gray-700 mb-2"
        >
          Department <span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <input
          id="department"
          type="number"
          formControlName="department"
          placeholder="Enter department ID"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <!-- Manager -->
      <div class="mb-8">
        <label
          for="manager"
          class="block text-2xl font-bold text-gray-700 mb-2"
        >
          Manager (ID)
        </label>
        <input
          id="manager"
          type="number"
          formControlName="manager"
          placeholder="Enter manager ID (optional)"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <!-- Buttons -->
      <div class="flex gap-4 mt-8">
        <button
          type="submit"
          [disabled]="employeeForm.invalid"
          class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg text-lg font-semibold transition disabled:opacity-50"
        >
          Save
        </button>
        <button
          type="button"
          (click)="onCancel()"
          class="bg-gray-200 hover:bg-gray-300 text-gray-700 px-6 py-2 rounded-lg text-lg font-semibold transition"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
